import Helpers from '../inc/Helpers';
import Ajax from '../inc/Ajax';
import autosize from 'autosize';
import 'slick-carousel';

class Albums {
    constructor() {
        this.helpers = new Helpers();
        this.ajax = new Ajax();

        this.albumID = sarypak.PHPToJS.public.albumID;
    }

    init() {
        let self = this;

        self.carousel();
        self.videoHeroSize();
        self.itemReacting();
        self.newCommentTextarea('autosize');
        self.newCommentSubmit();
        self.commentDeletion();
        self.loadMoreComments();
    }

    carousel() {
        let self = this;

        let itemType = $('body').data('itemType');
        let directItemID = sarypak.PHPToJS.public.albumDirectItemID;
        let slider = $('.album-carousel-slider');
        let slideCount = parseInt(slider.attr('data-slide-count'));
        let heroWrapper = $('.album-carousel-hero');
        let heroPhoto = $('.album-carousel-hero.photo img');
        let heroVideo = $('.album-carousel-hero.video iframe');
        let firstVideoYoutubeUrl = heroVideo.data('first-video-youtube-url');
        let loginLink = $('.col-login-needed a');
        let mainSection = $('section.main');
        let colReactions = $('.col-reactions');
        let colComments = $('.col-comments');
        let isCommentDirectLink = window.location.href.includes('comment_id=');
        let currentSlide = {};
        let currentItemID = '';

        const handleVoidDirectItem = function (src) {
            if (typeof(src) === 'undefined') {
                mainSection.remove();
                window.location.href = sarypak.PHPToJS.routes.error404;
            }
        };

        const scrollToThePoint = function () {
            let commentID = self.helpers.getURLQueryParam('comment_id');
            let selectedComment = $('#' + commentID);
            
            if (selectedComment.length === 0) {
                self.helpers.scrollToElement('default', heroWrapper, -20);
            } else {
                self.helpers.scrollToElement('default', selectedComment, -20);
            }

            self.helpers.removeURLQueryParam('comment_id', window.location.href);
        };

        const fillHeroPhotoWrapper = function (src) {
            heroPhoto.attr('src', src)
                     .fadeIn(150)
            ;

            handleVoidDirectItem(src);
        };

        const fillHeroVideoWrapper = function (src) {
            heroVideo.attr('src', src);
            handleVoidDirectItem(src);
        };

        const goToCurrentSlide = function () {
            let selectedItem = slider.find('.slick-current img');
            let selectedPhotoSrc = selectedItem.attr('src');
            let selectedPhotoShortPath = selectedItem.attr('data-photo-short-path'); 
            let selectedPhotoUrlPath = selectedItem.attr('data-photo-url-path');
            let selectedPhotoUrlDirectLogin = sarypak.PHPToJS.routes.login + '?r=' + selectedPhotoUrlPath;
            let selectedPhotoPermalink = selectedItem.attr('data-photo-permalink');
            let selectedVideoSrc = selectedItem.attr('data-video-src');
            let selectedVideoUrlPath = selectedItem.attr('data-video-url-path');
            let selectedVideoUrlDirectLogin = sarypak.PHPToJS.routes.login + '?r=' + selectedVideoUrlPath;
            let selectedVideoDatabaseID = selectedItem.attr('data-video-database-id'); 
            let selectedVideoPermalink = selectedItem.attr('data-video-permalink');

            let data = {
                reactionType: 'like',
                photoShortPath: selectedPhotoShortPath,
                videoDatabaseID: selectedVideoDatabaseID
            };

            const done = function (response) {
                colReactions.html(response.reactionsHtmlBlock)
                            .css('opacity', 1)
                ;
                colComments.find('> .block-body')
                           .html(response.newCommentHtmlBlock)
                ;
                colComments.find('> .block-footer')
                           .html(response.commentsHtmlBlock)
                ;
                colComments.find('> .block-footer')
                           .append(response.loadMoreCommentsHtmlBlock)
                ;
                colComments.css('opacity', 1);
                self.newCommentTextarea('autosize');
            };

            const fail = function () {};

            const always = function () {};

            if (itemType === 'photo')
            {
                fillHeroPhotoWrapper(selectedPhotoSrc);
                window.history.pushState('', '', selectedPhotoPermalink);
                loginLink.attr('href', selectedPhotoUrlDirectLogin);
            }
            else if (itemType === 'video')
            {
                fillHeroVideoWrapper(selectedVideoSrc);
                window.history.pushState('', '', selectedVideoPermalink);
                loginLink.attr('href', selectedVideoUrlDirectLogin);
            }

            $(window).on('popstate', function () {
                window.location.reload();
            });

            self.ajax.get(window.location.href, 'JSON', data, done, fail, always);
        }
        
        slider.slick({
            infinite: true,
            slidesToShow: 9,
            slidesToScroll: 1,
            focusOnSelect: false,
            swipe: false,
            prevArrow: '<button class="btn btn-primary previous"><i class="fas fa-chevron-left"></i></button>',
            nextArrow: '<button class="btn btn-primary next"><i class="fas fa-chevron-right"></i></button>',
            responsive: [
                {
                    breakpoint: sarypak.breakpoints.sm,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: sarypak.breakpoints.md,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: sarypak.breakpoints.lg,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: sarypak.breakpoints.xl,
                    settings: {
                        slidesToShow: 12
                    }
                }
            ]
        });

        let slickTrack = slider.find('.slick-track');
        let slides = slider.find('.slick-slide');
        let slideItemDivs = slides.find('div');
        let slickArrows = slider.find('.slick-arrow');

        slideItemDivs.css({
            width: slides.width(),
            height: slides.width()
        });

        if (isCommentDirectLink) {
            scrollToThePoint();
        }

        if (itemType === 'video') {
            fillHeroVideoWrapper(firstVideoYoutubeUrl);
        }

        if (directItemID && directItemID !== '') {
            let directItem = $('[data-direct-item-id="' + directItemID + '"]');
            let directPhotoSrc = directItem.attr('src');
            let directVideoSrc = directItem.attr('data-video-src');
            let directItemSlide = directItem.closest('.slick-slide');
            let directItemSlickIndex = parseInt(directItemSlide.attr('data-slick-index'));
            let haveSlickArrows = slider.find('.slick-arrow').length > 0;

            if (directItemSlickIndex <= -2) {
                directItemSlickIndex += slideCount;
            }

            slider.slick('slickGoTo', directItemSlickIndex);

            if (!haveSlickArrows) {
                slickTrack.addClass('transform-initial');
            }

            switch (itemType) {
                case 'photo':
                    fillHeroPhotoWrapper(directPhotoSrc);
                    break;

                case 'video':
                    fillHeroVideoWrapper(directVideoSrc);
                    break;
            }
        }

        slides.on('click', function () {
            let thisSlide = $(this);

            slides.removeClass('slick-current');
            thisSlide.addClass('slick-current');

            colReactions.css('opacity', 0.7);
            colComments.css('opacity', 0.7);

            goToCurrentSlide();
        });

        slider.on('beforeChange', function () {
            currentSlide = slider.find('.slick-current');
            currentItemID = currentSlide.find('img')
                                        .attr('data-direct-item-id')
            ;
        });

        slickArrows.on('click', function () {
            let slideToHighlight = $('img[data-direct-item-id=' + currentItemID + ']').closest('.slick-slide');

            slides.removeClass('slick-current');
            slideToHighlight.addClass('slick-current');
        });
    }

    toggleSlickArrows(action) {
        let slickArrows = $('.album-carousel-slider .slick-arrow');

        switch (action) {
            case 'show':
                slickArrows.removeClass('d-none');
                break;

            case 'hide':
                slickArrows.addClass('d-none');
                break;
        }
    }

    videoHeroSize() {
        let wrapper = $('.album-carousel-hero.video');
        let embedder = wrapper.find('.embed-responsive');

        const setEmbedderSize = function () {
            let windowHeight = $(window).height();
            let wrapperWidth = wrapper.width();
            let embedderHeight = windowHeight - 159;
            let embedderWidth = embedderHeight * 16 / 9;

            if (embedderWidth > wrapperWidth) {
                embedderWidth = wrapperWidth;
                embedderHeight = embedderWidth * 9 / 16;
            }

            embedder.css('height', embedderHeight);
            embedder.css('width', embedderWidth);
        };

        setEmbedderSize();

        $(window).on('resize', function () {
            setEmbedderSize();
        });
    }

    itemReacting() {
        let self = this;

        let userID = parseInt($('body').data('user-id'));
        let userRole = $('body').data('user-role');
        let itemType = $('body').data('item-type');
        let isAuthenticated = parseInt($('body').data('is-authenticated')) === 1;
        let cannotCommentAndReact = parseInt($('body').data('cannot-comment-and-react')) === 1;

        $('body').on('click', '.album-reactions button.react', function () {
            let thisButton = $(this);
            let buttonWrapper = thisButton.closest('.album-reactions');
            let numberField = buttonWrapper.find('.number');
            let currentNumber = parseInt(numberField.html());
            let userAlreadyLiked = thisButton.data('user-already-liked');

            let data = {
                albumID: self.albumID,
                userID: userID,
                userRole: userRole,
                opID: thisButton.attr('data-op-id'),
                opRole: thisButton.attr('data-op-role'),
                reactionType: thisButton.data('reaction-type'),
                itemType: itemType,
                actionType: !userAlreadyLiked ? 'increase' : 'decrease',
                photoShortPath: thisButton.data('photo-short-path'),
                videoDatabaseID: parseInt(thisButton.data('video-database-id'))
            };

            if (!isAuthenticated || cannotCommentAndReact) {
                return;
            } else {
                if (!userAlreadyLiked) {
                    buttonWrapper.addClass('active');
                    numberField.html(currentNumber + 1);
                    thisButton.data('user-already-liked', 1);
                } else {
                    buttonWrapper.removeClass('active');
                    numberField.html(currentNumber - 1);
                    thisButton.data('user-already-liked', false);
                }
            }

            const done = function () {};

            const fail = function () {
                numberField.html(currentNumber);
            };

            const always = function () {}

            self.ajax.post('/api/album/' + itemType + '/like', 'JSON', data, done, fail, always);
        });
    }

    newCommentTextarea(action) {
        let textarea = $('.album-new-comment textarea');

        switch (action) {
            case 'autosize':
                autosize(textarea);
                break;

            case 'reset':
                textarea.val('').css('height', 31.2);
                break;
        }
    }

    newCommentSubmit() {
        let self = this;

        $('body').on('keydown', '.album-new-comment form textarea', function (e) {
            let thisTextarea = $(this);

            if ((e.ctrlKey || e.metaKey) && (parseInt(e.keyCode) === 10 || parseInt(e.keyCode) === 13)) {
                thisTextarea.closest('form').trigger('submit');
            }
        });

        $('body').on('submit', '.album-new-comment form', function (e) {
            e.preventDefault();

            let thisForm = $(this);
            let textarea = thisForm.find('textarea');
            let submitBtn = thisForm.find('button');
            let formError = thisForm.find('.form-error');
            let commentsWrapper = thisForm.closest('.col-comments').find('> .block-footer');
            let data = thisForm.serializeArray();

            const done = function (response) {
                self.newCommentTextarea('autosize');
                self.newCommentTextarea('reset');
                commentsWrapper.prepend(response.commentHtmlBlock);
            };

            const fail = function () {
                formError.show();
            };

            const always = function () {
                submitBtn.removeAttr('disabled');
            };

            if (textarea.val().trim() === '') {
                textarea.addClass('error');
                return;
            } else {
                textarea.removeClass('error');
            }

            data.push({
                name: 'album_id',
                value: self.albumID
            });

            formError.hide();
            submitBtn.attr('disabled', 'disabled');

            self.ajax.post('/api/album/new-comment', 'JSON', data, done, fail, always);
        });
    }

    commentDeletion() {
        let self = this;

        $('body').on('click', '.album-comment .confirm', function (e) {
            e.preventDefault();

            let thisButton = $(this);
            let userDataHandler = thisButton.closest('.col-comments')
                                            .find('.col-new-comment .block-footer')
            ;
            let albumID = self.albumID;
            let userID = userDataHandler.find('[name="user_id"]')
                                        .val()
            ;
            let userRole = userDataHandler.find('[name="user_role"]')
                                          .val()
            ;
            let opID = userDataHandler.find('[name="op_id"]')
                                      .val()
            ;
            let opRole = userDataHandler.find('[name="op_role"]')
                                        .val()
            ;
            let itemType = userDataHandler.find('[name="item_type"]')
                                          .val()
            ;
            let photoShortPath = userDataHandler.find('[name="photo_short_path"]')
                                                .val()
            ;
            let videoID = userDataHandler.find('[name="video_database_id"]')
                                         .val()
            ;
            let commentWrapper = thisButton.closest('.album-comment');

            let data = {
                commentID: parseInt(thisButton.data('comment-id')),
                albumID: albumID,
                userID: userID,
                userRole: userRole,
                opID: opID,
                opRole: opRole,
                itemType: itemType,
                photoShortPath: photoShortPath,
                videoID: videoID
            };

            const done = function () {
                commentWrapper.fadeOut(150);
            };

            const fail = function () {};

            const always = function () {
                commentWrapper.css('opacity', 1);
            };

            commentWrapper.css('opacity', 0.7);

            self.ajax.post('/api/album/delete-comment', 'JSON', data, done, fail, always);
        });
    }

    loadMoreComments() {
        let self = this;

        $('body').on('click', '.load-more-comments a', function (e) {
            e.preventDefault();

            let thisButton = $(this);
            let nextPage = parseInt(thisButton.data('next-page'));
            let data = {
                page: nextPage,
                itemType: $('body').data('item-type'),
                photoShortPath: thisButton.data('photo-short-path'),
                videoDatabaseID: thisButton.data('video-database-id')
            }   

            const done = function (response) {
                thisButton.parent().before(response.htmlBlock);
                thisButton.data('next-page', nextPage + 1);

                if (!response.hasMorePages) {
                    thisButton.remove();
                }
            };

            const fail = function () {};

            const always = function () {};
            
            self.ajax.get('/api/album/load-more-comments', 'JSON', data, done, fail, always)
        });
    }
}

export default Albums;